import React from 'react';
import { StatusStep } from './StatusStep';

interface Step {
  active: boolean;
  label: string;
  date?: string;
}

interface StatusStepSequenceProps {
  steps: Step[];
}

export const StatusStepSequence: React.FC<StatusStepSequenceProps> = ({
  steps,
}) => {
  return (
    <div className="grid grid-rows-4 md:grid-cols-4 md:grid-rows-1 print:grid-rows-1 print:grid-cols-4 w-full">
      {steps.map((step, index) => (
        <StatusStep
          key={`${step.label}-${index}`}
          label={step.label}
          date={step.date}
          amount={steps.length}
          index={index}
          activeIndex={steps.findIndex((s) => s.active)}
        />
      ))}
    </div>
  );
};
